import { Settings } from '@config/game.js'
import {
  USER_GUIDE_BROWSE_ROUTE,
  USER_MOD_BROWSE_ROUTE,
  LOCALISATION_ROUTE,
  GUIDE_BROWSE_ROUTE,
  GUIDE_VIEW_ROUTE,
  MOD_BROWSE_ROUTE,
  FOUROHFOUR_ROUTE,
  MOD_VIEW_ROUTE,
  LIBRARY_ROUTE,
  USER_ROUTE,
} from '@config/routeNames.js'

const routes = [
  {
    path: '/',
    name: MOD_BROWSE_ROUTE,
    component: () =>
      import(/* webpackChunkName: "modio" */ '@views/ModBrowse.vue'),
    meta: { browse: true },
  },
  {
    path: '/u/:user/',
    name: USER_ROUTE,
    component: () =>
      import(/* webpackChunkName: "modio" */ '@views/UserView.vue'),
    children: [
      {
        name: USER_MOD_BROWSE_ROUTE,
        path: '',
        component: () =>
          import(/* webpackChunkName: 'modio' */ '@views/ModBrowse.vue'),
      },
      {
        name: USER_GUIDE_BROWSE_ROUTE,
        path: 'r',
        component: () =>
          import(/* webpackChunkName: 'modio' */ '@views/GuideBrowse.vue'),
      },
    ].filter(
      (route) =>
        route.name !== USER_GUIDE_BROWSE_ROUTE || Settings.value.showGuides
    ),
  },
  {
    path: '/m/:mod',
    name: MOD_VIEW_ROUTE,
    component: () =>
      import(/* webpackChunkName: "modio" */ '@views/ModView.vue'),
  },
  {
    path: '/library',
    name: LIBRARY_ROUTE,
    meta: { requiresAuth: true },
    component: () =>
      import(/* webpackChunkName: "modio" */ '@views/Library.vue'),
  },
  {
    path: '/localisation',
    name: LOCALISATION_ROUTE,
    component: () => import('@views/Localisation.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: FOUROHFOUR_ROUTE,
    component: () => import('@views/404.vue'),
  },
].filter((route) => route.name !== LOCALISATION_ROUTE || import.meta.env.DEV)

if (Settings.value.showGuides) {
  routes.push({
    path: '/r',
    name: GUIDE_BROWSE_ROUTE,
    component: () =>
      import(/* webpackChunkName: "modio" */ '@views/GuideBrowse.vue'),
    meta: { browse: true },
  })

  routes.push({
    path: '/r/:guide',
    name: GUIDE_VIEW_ROUTE,
    component: () =>
      import(/* webpackChunkName: 'modio' */ '@views/GuideView.vue'),
  })
}

export default routes
